import { OrderStatus } from '../types/purchases.types'

export enum StatusWithAddressAndNoHome {
	on_delivery = OrderStatus.on_delivery,
	in_store = OrderStatus.in_store,
	in_droppoint = OrderStatus.in_droppoint,
}
